<template>
  <div>
    <material-input
      v-model="model.firstname"
      label="Prénom de la Secrétaire"
      v-validate="'required'"
      data-vv-name="firstname"
      data-vv-as="Le prénom"
      :error="errors.first('firstname')"/>

    <material-input
      v-model="model.lastname"
      label="Nom de la Secrétaire"
      v-validate="'required'"
      data-vv-name="lastname"
      data-vv-as="Le nom"
      :error="errors.first('lastname')"/>

    <div class="fullPhone">
      <material-select class="prefix"
        v-model="model.countryCode"
        :label="'+' + countryPrefix"
        :options="prefixes" />

      <material-input type="phone" class="phone"
        v-model.trim="model.phoneNumber"
        label="Numéro de téléphone"
        :placeholder="phonePlaceholder"
        v-validate="'required|regex:^([0-9]{2} ?){4}$|unique_account:SECRETARY'"
        data-vv-name="phoneNumber"
        data-vv-as="Le numéro de téléphone"
        :error="errors.first('phoneNumber')"/>
    </div>

    <material-input type="email"
      v-model.trim="model.email"
      label="Adresse e-mail"
      v-validate="'email'"
      data-vv-name="email"
      data-vv-as="L'adresse e-mail"
      :error="errors.first('email')"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import MaterialInput from '@/components/MaterialInput'
import MaterialSelect from '@/components/MaterialSelect'

export default {
  components: {
    MaterialInput,
    MaterialSelect
  },

  data () {
    return {
      model: null,
      prefixes: [{
        value: '221',
        text: 'Sénégal (+221)',
        shortText: '+221'
      }, {
        value: '229',
        text: 'Bénin (+229)',
        shortText: '+229'
      }]
    }
  },

  computed: {
    ...mapGetters(['secretary', 'countryPrefix']),

    phonePlaceholder () {
      return this.countryPrefix === '229'
        ? '97970000'
        : '77000000'
    }
  },

  watch: {
    model: {
      deep: true,
      handler (model) {
        this.setSecretary(model)
      }
    }
  },

  beforeMount () {
    this.model = this.secretary
  },

  methods: {
    ...mapActions(['addHospitalAgent', 'setSecretary']),

    async validate () {
      try {
        return await this.$validator.validateAll()
      } catch (error) {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
  .container-step-2 {
    max-width: 540px;
    margin: 0 auto;
  }

  .fullPhone {
    position: relative;
  }

  .prefix {
    width: 100px !important;
    position: absolute !important;
  }

  .phone {
    margin-left: 55px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/register/step3.vue